import React from "react";
import { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Modal, Button, Textarea, Label } from "flowbite-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import LogoComponent from "./LogoComponent";
import heclogo from "../assets/img/heclogo.png";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import { getUserRole } from "../utils/auth";
import { 
  GraduationCap, 
  MapPin, 
  Globe, 
  Building2, 
  Calendar, 
  Clock, 
  Search, 
  FileText, 
  Users, 
  AlertTriangle,
  CheckCircle,
  XCircle,
  Timer,
  ArrowRight,
  BookOpen,
  School,
  CalendarClock,
  Award,
  ArrowLeft
} from "lucide-react";

export default function SignIn() {
  // Add custom animations
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fade-in-up {
        0% {
          opacity: 0;
          transform: translateY(20px);
        }
        100% {
          opacity: 1;
          transform: translateY(0);
        }
      }
      .animate-fade-in-up {
        animation: fade-in-up 0.6s ease-out forwards;
      }
      .line-clamp-2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .line-clamp-3 {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  //for HEC User Account
  const [isHec, setHec] = useState(false);

  const [login, setLogin] = useState(true);
  const [register, setRegister] = useState(false);
  const [localLoan, setLocalLoan] = useState(false);
  const [applicationForm, setApplicationForm] = useState(true);
  const [createAccount, setCreateAccount] = useState(false);
  const [forgetPassword, setForgetPassword] = useState(false);
  
  // Show local loan options
  const [showLocalLoanOptions, setShowLocalLoanOptions] = useState(false);

  //avoid triggering useEffect when someone is not not placed abutton
  const [pressedRegNumber, setPressedRegNumber] = useState(false);
  //checking study area is selected
  //const [selectedArea, setSelectedArea] = useState(false);
  //check if loan category is selected
  const [selectedVillage, setSelectedVillage] = useState(false);

  const [registrationNumber, setRegistrationNumber] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [gender, setGender] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [nationalId, setNationalId] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [motherName, setMotherName] = useState("");
  const [guardianName, setGuardianName] = useState("");
  const [indexNumber, setIndexNumber] = useState("");
  const [email, setEmail] = useState("");
  const [marks, setMarks] = useState("");
  const [combination, setCombination] = useState("");
  const [applyingAcademic, setApplyingAcademic] = useState("");
  const [completionYear, setCompletionYear] = useState("");
  const [studyArea, setStudyArea] = useState("");
  const [loanCategory, setLoanCategory] = useState(
    "Tuition Fees and Living Allowance"
  );
  const [college, setCollege] = useState("");
  const [qualification, setQualification] = useState("");
  const [campus, setCampus] = useState("");
  const [educationLevel, setEducationLevel] = useState("");
  const [district, setDistrict] = useState("");
  const [sector, setsector] = useState("");
  const [cell, setCell] = useState("");
  const [village, setVillage] = useState("");

  //checking marks
  const [checkResultRegNumber, setCheckResultRegNumber] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [bursaryStatus, setBursaryStatus] = useState("");

  //This is to be used to calculate the total marks to be considered for selection.
  const [perforamanceScore, setPerformanceScore] = useState("");
  const [qualificationScore, setQualificationScore] = useState("");
  const [totalScore, setTotalScore] = useState("");

  const [sectors, setSectors] = useState([]);
  const [cells, setCells] = useState([]);
  const [villages, setVillages] = useState([]);
  const [studyAreas, setStudyAreas] = useState([]);

  const [combinations, setCombinations] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);

  //create account
  const [firstNameAccount, setFirstNameAccount] = useState("");
  const [lastNameAccount, setLastNameAccount] = useState("");
  const [genderAccount, setGenderAccount] = useState("");
  const [emailAccount, setEmailAccount] = useState("");
  const [passwordAccount, setPasswordAccount] = useState("");
  const [passwordCheck, setPasswordCheck] = useState("");
  const [phoneNumberAccount, setPhoneNumberAccount] = useState("");
  const [nationalIdAccount, setNationalIdAccount] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [passwordStrength, setPasswordStrength] = useState({
    score: 0,
    feedback: [],
    isValid: false,
  });
  //for scholarship data
  const [scholarshipData, setScholarshipData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Only scholarships whose application window is currently open
  const openScholarships = useMemo(() => {
    const now = new Date();
    return scholarshipData.filter(
      (s) => now >= new Date(s.startDate) && now <= new Date(s.endDate)
    );
  }, [scholarshipData]);
  
  // Auto-scroll state
  const [isAutoScrolling, setIsAutoScrolling] = useState(true);
  const [scrollPosition, setScrollPosition] = useState(0);
  const scrollContainerRef = useRef(null);

  // Password strength validation function
  const validatePasswordStrength = (password) => {
    const feedback = [];
    let score = 0;

    // Check length (minimum 8 characters)
    if (password.length < 8) {
      feedback.push("Password must be at least 8 characters long");
    } else {
      score += 1;
    }

    // Check for uppercase letter
    if (!/[A-Z]/.test(password)) {
      feedback.push("Password must contain at least one uppercase letter");
    } else {
      score += 1;
    }

    // Check for lowercase letter
    if (!/[a-z]/.test(password)) {
      feedback.push("Password must contain at least one lowercase letter");
    } else {
      score += 1;
    }

    // Check for number
    if (!/\d/.test(password)) {
      feedback.push("Password must contain at least one number");
    } else {
      score += 1;
    }

    // Check for special character
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
      feedback.push("Password must contain at least one special character");
    } else {
      score += 1;
    }

    const isValid = score >= 4 && password.length >= 8;

    return { score, feedback, isValid };
  };

  //login In
  const [emailLogIn, setEmailLogIn] = useState("");
  const [passwordLogIn, setPasswordLogIn] = useState("");
  const [openModalLogin, setOpenModalLogin] = useState(false);

  //Update phone number and national id
  const [openModalForUpdate, setOpenModalForUpdate] = useState(false);

  //CLAIM
  const [openClaimModal, setOpenClaimModal] = useState(false);
  //Scholarship Modal
  const [openScholarshipModal, setOpenScholarshipModal] = useState(false);
  //claim
  const [claim, setClaim] = useState("");
  const [claimType, setClaimType] = useState("");
  const [claimRegistration, setClaimRegistration] = useState("");

  //forgot password
  const [emailForget, setEmailForget] = useState("");
  const [emailSendSucceed, setEmailSendSucceed] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [token, setToken] = useState("");
  const [loginAuthen, setLoginAuthen] = useState("");

  const [userRole, setUserRole] = useState("");

  const nav = useNavigate();

  const authenticationData = {
    userName: emailLogIn.trim(),
    password: passwordLogIn,
  };

  const logout = async () => {
    try {
      const token = sessionStorage.getItem('token');
      if (token) {
        // Call backend to log the logout
        await fetch(`${process.env.REACT_APP_BASE_URL}hec/log-info/logout`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }).catch(err => console.error('Failed to log logout:', err));
      }
    } catch (error) {
      console.error('Error during logout:', error);
    } finally {
      sessionStorage.clear();
      nav("/",{replace:true});
      setEmailLogIn("");
      setPasswordLogIn("");
      setOpenModalLogin(false);
    }
  };

  const loginAuthenticationToken = async (emailForget, reset) => {
    await axios
      .get(
        process.env.REACT_APP_BASE_URL +
          "hec/users/resetPassword?userName=" +
          emailForget +
          "&tokenType=" +
          reset
      )
      .then((response) => {
        return true;
      })
      .catch((error) => {
        return false;
      });
  };


  const getStatusColor = (status) => {
    switch (status) {
      case "Open":
        return "bg-green-100 text-green-800";
      case "Closing Soon":
        return "bg-red-100 text-red-800 animate-pulse";
      case "Coming Soon":
        return "bg-orange-100 text-orange-800";
      case "Closed":
        return "bg-gray-100 text-gray-800";
      default:
        return "bg-blue-100 text-blue-800";
    }
  };

  const fetchScholarshipsByAcademicYearDiv = () => {
    if (loading) {
      return (
        <div className="w-full h-screen flex items-center justify-center ">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-800 mx-auto mb-4"></div>
            <p className="text-cyan-800 font-medium">Loading Scholarships...</p>
          </div>
        </div>
      );
    }

    return (
      <div className="w-full h-screen overflow-hidden relative bg-[#f9fafb] pb-10">
        {/* Header */}
        <div className=" backdrop-blur-sm  p-6 sticky top-0 z-10">
          <div className="text-center">
            <div className="flex items-center justify-center gap-2 mb-2">
              <GraduationCap className="w-8 h-8 text-cyan-900" />
              <h2 className="text-3xl font-bold text-cyan-900">
                Available Scholarships
              </h2>
            </div>
            <p className="text-cyan-700 text-sm flex items-center justify-center gap-1">
              <Globe className="w-4 h-4" />
              Discover the scholarship opportunities
            </p>
            <div className="flex items-center justify-center gap-4 mt-4">
              <div className="inline-flex items-center px-3 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full">
                <CheckCircle className="w-3 h-3 mr-2 text-green-600" />
                {scholarshipData.filter(s => { const now = new Date(); return now >= new Date(s.startDate) && now <= new Date(s.endDate); }).length} Open Scholarship Opportunities . Login for More Information
              </div>
             
            </div>
          </div>
        </div>

        {/* Scholarships Container */}
        <div 
          ref={scrollContainerRef}
          className="h-full overflow-y-auto pb-20 px-4 bg-[#f9fafb]"
          onMouseEnter={() => setIsAutoScrolling(false)}
          onMouseLeave={() => setIsAutoScrolling(true)}
        >
          {scholarshipData.filter(s => { const now = new Date(); return now >= new Date(s.startDate) && now <= new Date(s.endDate); }).length > 0 ? (
            <div className="space-y-6 py-6">
              {scholarshipData.filter(s => { const now = new Date(); return now >= new Date(s.startDate) && now <= new Date(s.endDate); }).map((scholarship, index) => {
                // Calculate status based on dates
                const now = new Date();
                const endDate = new Date(scholarship.endDate);
                const startDate = new Date(scholarship.startDate);
                const daysUntilEnd = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));
                
                let status = 'Open';
                if (now > endDate) {
                  status = 'Closed';
                } else if (daysUntilEnd <= 7) {
                  status = 'Closing Soon';
                } else if (now < startDate) {
                  status = 'Coming Soon';
                }

                return (
                  <div
                    key={scholarship.id}
                    className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-6 transform hover:scale-[1.02] transition-all duration-300 hover:shadow-xl animate-fade-in-up"
                    style={{
                      animationDelay: `${index * 0.1}s`
                    }}
                  >
                    {/* Scholarship Header */}
                    <div className="flex items-start justify-between mb-4">
                      <div className="flex-1">
                        <h3 className="text-xl font-bold text-gray-900 mb-2 line-clamp-2">
                          {scholarship.name}
                        </h3>
                        <div className="flex items-center gap-2 mb-3">
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                            <Globe className="w-3 h-3 mr-1" />
                            {scholarship.countryName}
                          </span>
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                            <Building2 className="w-3 h-3 mr-1" />
                            {scholarship.scholarshipType}
                          </span>
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            <BookOpen className="w-3 h-3 mr-1" />
                            {scholarship.educationPrograms?.length || 0} Programs
                          </span>
                        </div>
                      </div>
                      <div className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor(status)}`}>
                        {status}
                      </div>
                    </div>

                    {/* Scholarship Description */}
                    <div className="space-y-4">
                      {scholarship.description && (
                        <p className="text-gray-600 text-sm line-clamp-3 bg-gray-50 p-3 rounded-lg">
                          {scholarship.description}
                        </p>
                      )}
                      
                      {/* Timeline */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        <div className="flex items-center text-green-600">
                          <Calendar className="w-4 h-4 mr-2" />
                          Start: {new Date(scholarship.startDate).toLocaleDateString()}
                        </div>
                        <div className="flex items-center text-red-600">
                          <CalendarClock className="w-4 h-4 mr-2" />
                          Deadline: {new Date(scholarship.endDate).toLocaleDateString()}
                        </div>
                      </div>

                      {/* Education Programs */}
                      {scholarship.educationPrograms && scholarship.educationPrograms.length > 0 && (
                        <div className="bg-gray-50 rounded-lg p-4">
                          <h4 className="font-semibold text-cyan-900 text-sm mb-3 flex items-center">
                            <BookOpen className="w-4 h-4 mr-2" />
                            Available Programs ({scholarship.educationPrograms.length})
                          </h4>
                          <div className="space-y-3">
                            {scholarship.educationPrograms.map((program, programIndex) => (
                              <div key={program.id} className="bg-white rounded-lg p-3 shadow-sm">
                                <div className="flex items-start justify-between mb-2">
                                  <h5 className="font-medium text-gray-900 text-sm">
                                    {program.programName}
                                  </h5>
                                  <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                                    {program.studyYears} years
                                  </span>
                                </div>
                                <div className="flex items-center text-xs text-gray-600 mb-2">
                                  <School className="w-3 h-3 mr-1" />
                                  {program.universityName}
                                </div>
                                <div className="flex items-center text-xs text-gray-500">
                                  <Calendar className="w-3 h-3 mr-1" />
                                  {new Date(program.startDate).toLocaleDateString()} - {new Date(program.endDate).toLocaleDateString()}
                                </div>
                                
                                {/* Requirements */}
                                {program.requirements && program.requirements.length > 0 && (
                                  <div className="mt-2">
                                    <p className="text-xs font-medium text-gray-700 mb-1">Requirements:</p>
                                    <div className="flex flex-wrap gap-1">
                                      {program.requirements.map((req, reqIndex) => (
                                        <span key={req.id} className="inline-flex items-center px-2 py-1 rounded-md text-xs bg-blue-100 text-blue-800">
                                          <FileText className="w-3 h-3 mr-1" />
                                          {req.name}
                                        </span>
                                      ))}
                                      {/* {program.requirements.length > 3 && (
                                        <span className="inline-flex items-center px-2 py-1 rounded-md text-xs bg-gray-100 text-gray-600">
                                          +{program.requirements.length - 3} more
                                        </span>
                                      )} */}
                                    </div>
                                  </div>
                                )}
                              </div>
                            ))}
                            {/* {scholarship.educationPrograms.length > 2 && (
                              <div className="text-center">
                                <span className="text-xs text-cyan-700 bg-cyan-100 px-3 py-1 rounded-full">
                                  +{scholarship.educationPrograms.length - 2} more programs available
                                </span>
                              </div>
                            )} */}
                          </div>
                        </div>
                      )}

                      {/* Call to Action */}
                      <div className="flex items-center justify-between pt-3 border-t border-gray-200">
                        <div className="flex items-center text-xs text-gray-500">
                          <Calendar className="w-3 h-3 mr-1" />
                          Posted: {new Date(scholarship.creationDate).toLocaleDateString()}
                        </div>
                        <div className="flex gap-2">
                          {status === 'Open' || status === 'Closing Soon' ? (
                            <button className="bg-gradient-to-r from-cyan-600 to-cyan-700  text-white px-4 py-2 rounded-lg text-xs font-medium hover:from-cyan-700 hover:to-blue-700 transition-all duration-200 transform hover:scale-105 shadow-md flex items-center" onClick={() => setHec(true)}>
                              <ArrowLeft className="w-3 h-3 mr-2"/>
                              Login to Apply
                            </button>
                          ) : status === 'Coming Soon' ? (
                            <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-4 py-2 rounded-lg text-xs font-medium cursor-not-allowed opacity-75 flex items-center">
                              <Timer className="w-3 h-3 mr-1" />
                              Opening Soon
                            </div>
                          ) : (
                            <div className="bg-gradient-to-r from-gray-400 to-gray-500 text-white px-4 py-2 rounded-lg text-xs font-medium cursor-not-allowed opacity-75 flex items-center">
                              <XCircle className="w-3 h-3 mr-1" />
                              Applications Closed
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Urgency Indicator */}
                      {status === 'Closing Soon' && (
                        <div className="bg-red-50 border border-red-200 rounded-lg p-3 flex items-center">
                          <AlertTriangle className="w-4 h-4 mr-2 text-red-600 animate-pulse" />
                          <span className="text-red-700 text-xs font-medium">
                            Hurry! Only {daysUntilEnd} day{daysUntilEnd !== 1 ? 's' : ''} left to apply
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="flex items-center justify-center h-full">
              <div className="text-center bg-white/80 backdrop-blur-sm rounded-xl p-8 shadow-lg">
                <Search className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                <h3 className="text-xl font-bold text-gray-900 mb-2">No Open Scholarships</h3>
                <p className="text-gray-600">There are no currently open scholarships. Check back later for new opportunities!</p>
              </div>
            </div>
          )}
        </div>        
      </div>
    );
  };
  const authentication = async () => {
    // if (
    //   emailLogIn !== "dushimimanapatrick@gmail.com" &&
    //   emailLogIn !== "dushimimanapatrick1@gmail.com" &&
    //   emailLogIn !== "cirere@mineduc.gov.rw" &&
    //   emailLogIn !== "tgasangwa@hec.gov.rw" &&
    //   emailLogIn !== "dgacinya@hec.gov.rw" &&
    //   emailLogIn !== "ekadozi@hec.gov.rw"
    // ) {
    //   return;
    // }
    if (emailLogIn && passwordLogIn) {
      await axios
        .get(process.env.REACT_APP_BASE_URL + "hec/users/login", {
          params: authenticationData,
        })
        .then((response) => {
          if (response.status === 200) {
            //loginAuthenticationToken(authenticationData.userName, "LOGIN");

            //save data in session storage
            sessionStorage.setItem("token", response.data.message); // JWT token only

          
            // Store ALL scholarship permissions (a user can own several scholarships).
            // Falls back to the old single userPermission field for older API versions.
            const permissionNames = (
              response.data.userPermissions?.length
                ? response.data.userPermissions
                : response.data.userPermission
                ? [response.data.userPermission]
                : []
            ).map((permission) => permission.permissionName);
            sessionStorage.setItem(
              "userPermission",
              JSON.stringify(permissionNames)
            );
            
            // Get role from the decoded JWT token (more secure)
            const currentUserRole = getUserRole();
            setUserRole(currentUserRole);
            //setOpenModalLogin(true);

            
  
            //temporally for UAT and before fixing the issue of email.
            if (currentUserRole === "Admin" || currentUserRole === "DG") {
              nav("/dashboard");
            } else if (currentUserRole === "SCHOLARSHIP_OWNER") {
              nav("/applicantsList");
            } else if (currentUserRole === "HLI_ADMIN") {
              nav("/hliAdmin");
            } else {
              nav("/studentPortal");
            }
          } else {
            toast.warning(
              "Invalid User Name or Password, please double check again",
              {
                position: "top-center",
                autoClose: 10000,
                theme: "colored",
              }
            );
          }
        })
        .catch((error) => {
          toast.info("Invalid User Name  or password", {
            position: "top-center",
            autoClose: 15000,
            theme: "colored",
          });
        });
    } else {
      toast.warning("Please, provide all neccessary information", {
        position: "top-center",
        autoClose: 15000,
        theme: "colored",
      });
    }
  };

  const applicationData = {
    firstName: firstName,
    lastName: lastName,
    idNumber: nationalId,
    regNumber: registrationNumber,
    email: email,
    phoneNumber: phoneNumber,
    academicYearId: applyingAcademic,
    studyAreaId: studyArea,
    loanCategory: loanCategory,
    marks: marks,
    combinationId: combination,
    completionYearId: completionYear,
    fatherName: fatherName,
    motherName: motherName,
    gardian: guardianName,
    gender: gender,
    indexNumber: indexNumber,
    performanceScore: perforamanceScore,
    qualificationScore: qualificationScore,
    totalScore: totalScore,
    sectorId: sector,
    cellId: cell,
    villageId: village,
  };

  const createAccountData = {
    firstName: firstNameAccount,
    lastName: lastNameAccount,
    userName: emailAccount.trim(),
    email: emailAccount.trim(),
    password: passwordAccount,
    gender: genderAccount,
    nationalId: nationalIdAccount,
    phoneNumber: phoneNumberAccount,
  };

  const clearTheInputCreate = () => {
    setFirstNameAccount("");
    setLastNameAccount("");
    setGenderAccount("");
    setPhoneNumberAccount("");
    setNationalIdAccount("");
    setEmailAccount("");
    setPasswordAccount("");
    setPasswordCheck("");
  };
  const clearTheInput = () => {
    setRegistrationNumber("");
    setFirstName("");
    setLastName("");
    setGender("");
    setMotherName("");
    setFatherName("");
    setGuardianName("");
    setPhoneNumber("");
    setNationalId("");
    setEmail("");
    setIndexNumber("");
    setMarks("");
    setStudyArea("");
    setApplyingAcademic("");
    setCampus("");
    setCollege("");
    setQualification("");
    setEducationLevel("");
    setCompletionYear("");
    setLoanCategory("");
    setCombination("");
    setDistrict("");
    setsector("");
    setCell("");
    setVillage("");
  };

  const clearTheInPutGetBursary = () => {
    setFirstName("");
    setLastName("");
    setGender("");
    setMotherName("");
    setFatherName("");
    setGuardianName("");
    setPhoneNumber("");
    setNationalId("");
    setEmail("");
    setIndexNumber("");
    setMarks("");
    setStudyArea("");
    setApplyingAcademic("");
    setCampus("");
    setCollege("");
    setQualification("");
    setEducationLevel("");
    setCompletionYear("");
    setLoanCategory("");
    setCombination("");
    setDistrict("");
    setsector("");
    setCell("");
    setVillage("");
  };

  const applyForLocalLoan = async () => {
    if (
      registrationNumber &&
      firstName &&
      lastName &&
      nationalId &&
      fatherName &&
      motherName &&
      indexNumber &&
      qualification &&
      college &&
      selectedVillage
    ) {
      await axios
        .post(
          process.env.REACT_APP_BASE_URL + "hec/localLoan/saveLocalLoan",
          applicationData
        )
        .then((response) => {
          if (response.data === "Loan request not yet opened") {
            toast.warning(
              "Loan request process is not yet opened. Please, be patient.",
              {
                position: "top-center",
                autoClose: 15000,
                theme: "colored",
              }
            );
            clearTheInput();
          } else {
            toast.success("The Local loan request is succcessfully received.", {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            });
            clearTheInput();
          }
        })
        .catch((error) => {
          const status = error.response ? error.response.status : null;
          const serverMessage =
            error.response && typeof error.response.data === "string"
              ? error.response.data
              : null;
          if (status === 409) {
            toast.error("Your local loan is already received", {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            });
            clearTheInput();
          } else if ((status === 404 || status === 400) && serverMessage) {
            // Backend could not resolve the student's institution (unknown
            // registration number or missing college/institution link).
            toast.error(serverMessage, {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            });
          } else {
            toast.info("Please, Try again", {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            });
            clearTheInput();
          }
        });
    } else {
      toast.warning("Please, provide all neccessary information", {
        position: "top-center",
        autoClose: 15000,
        theme: "colored",
      });
    }
  };

  const updatePhoneNumber = async () => {
    if (registrationNumber && nationalId && phoneNumber) {
      // if (!regNumbers.includes(registrationNumber)) {
      //   toast.warning(
      //     "Applicable only to students who have submitted an appeal.",
      //     {
      //       position: "top-center",
      //       autoClose: 15000,
      //       theme: "colored",
      //     }
      //   );
      //   return;
      // }
      await axios
        .put(
          process.env.REACT_APP_BASE_URL +
            `hec/busaryApplication/updateApplication?regNumber=${registrationNumber}&nationalId=${nationalId}&phoneNumber=${phoneNumber}`
        )
        .then((response) => {
          clearTheInPutGetBursary();
          toast.success(
            "Your National ID and phone Number are successfully updated",
            {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            }
          );
        })
        .catch((error) => {
          clearTheInPutGetBursary();
          toast.warning(
            "National and phone Number not updated, check your regNumber",
            {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            }
          );
          return null;
        });
    } else {
      clearTheInPutGetBursary();
      toast.warning(
        "National and phone Number not updated, check your regNumber",
        {
          position: "top-center",
          autoClose: 15000,
          theme: "colored",
        }
      );
      return null;
    }
  };

  const getBursaryApplication = async () => {
    if (registrationNumber) {
      // if (!regNumbers.includes(registrationNumber)) {
      //   toast.warning(
      //     "Applicable only to students who have submitted an appeal.",
      //     {
      //       position: "top-center",
      //       autoClose: 15000,
      //       theme: "colored",
      //     }
      //   );
      //   return;
      // }
      await axios
        .get(
          process.env.REACT_APP_BASE_URL +
            "hec/busaryApplication/getByRegistrationNumber",
          {
            params: { registrationNumber: registrationNumber },
          }
        )
        .then((response) => {
          //This is the condition
          //if (response.data.state === 1) {
          setFirstName(response.data.firstName);
          setLastName(response.data.lastName);
          setGender(response.data.gender);
          setPhoneNumber(response.data.phoneNumber);
          setNationalId(response.data.nationalId);
          setEmail(response.data.email);
          setIndexNumber(response.data.indexNumber);
          setMarks(response.data.s6Aggregate);
          setCollege(response.data["college"]?.collegeName);
          setQualification(response.data["qualification"]?.qualifactionCode);
          setCampus(response.data.campusName);
          setEducationLevel(response.data.educationLevel);
          setCombination(response.data["combination"]?.combinationCode);
          setStudyArea(
            response.data["qualification"]["studyAreaId"]?.studyAreaName
          );
          setApplyingAcademic(response.data["academicYear"]?.academicYearName);
          setCompletionYear(response.data.completionYearCode);

          setPerformanceScore(
            process.env.REACT_APP_WEIGHT_ALLOCATED -
              (process.env.REACT_APP_MAX_PERFORMANCE -
                response.data.s6Aggregate)
          );
          setQualificationScore(
            response.data["qualification"]["studyAreaId"]?.studyAreaWeight
          );
          setTotalScore(
            process.env.REACT_APP_WEIGHT_ALLOCATED -
              (process.env.REACT_APP_MAX_PERFORMANCE -
                response.data.s6Aggregate) +
              response.data["qualification"]["studyAreaId"].studyAreaWeight
          );
          // } else {
          //   toast.warning("You are not allowed to apply for this application", {
          //     position: "top-center",
          //     autoClose: 15000,
          //     theme: "colored",
          //   });
          //   clearTheInPutGetBursary();
          //   return null;
          // }
        })
        .catch((error) => {
          clearTheInPutGetBursary();
          toast.warning(
            `That admission number is not found. Double check your number and try again, Eligible candidates are those completed S6 in year of ${new Date().getFullYear()} and admitted at UR/RP/RICA)`,
            {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            }
          );
          return null;
        });
    }
  };

  const clearResultFild = () => {
    setFirstName("");
    setLastName("");
    setNationalId("");
    setIndexNumber("");
    setRegistrationNumber("");
    setStudyArea("");
    setBursaryStatus("");
    setCheckResultRegNumber("");
  };

  const getResultByRegNumber = async () => {
    setPressedRegNumber(false);
    if (checkResultRegNumber) {
      await axios
        .get(
          process.env.REACT_APP_BASE_URL +
            `hec/localLoan/getLocalLoanByRegNumber?regNumber=${checkResultRegNumber}`
        )
        .then((response) => {
          setFirstName(response.data.firstName);
          setLastName(response.data.lastName);
          setNationalId(response.data.idNumber);
          setIndexNumber(response.data.indexNumber);
          setRegistrationNumber(response.data.regNumber);
          setStudyArea(response.data.studyAreaId);
          setBursaryStatus(response.data.status);
          setOpenModal(true);
        })
        .catch((error) => {
          if (error.response?.status === 404) {
            toast.warning(
              "The selected Students for bursary are not yet published. Please be patient",
              {
                position: "top-center",
                autoClose: 15000,
                theme: "colored",
              }
            );
            return null;
          } else {
            toast.info(
              "That registration number is not found. Double check your number and try again.",
              {
                position: "top-center",
                autoClose: 15000,
                theme: "colored",
              }
            );
            return null;
          }
        });
    }
  };

  const fetchDistricts = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "hec/location/getDistricts"
      );
      const distrctsList = await response.data;
      setDistricts(distrctsList);
      return distrctsList;
    } catch {
      return null;
    }
  };

  const fetchStudyAreas = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "hec/studyArea/getStudyAreas"
      );
      const studyAreasList = await response.data;
      setStudyAreas(studyAreasList);
      return studyAreasList;
    } catch {
      return null;
    }
  };

  const fetchLocations = async (parentCode, typeLocation) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "hec/location/getLocaitonsByParent",
        {
          params: { parentCode: parentCode },
        }
      );
      const locationList = await response.data;
      if (typeLocation === "DISTRICT") {
        setSectors(locationList);
      } else if (typeLocation === "SECTOR") {
        setCells(locationList);
      } else if (typeLocation === "CELL") {
        setVillages(locationList);
      }
    } catch {
      return null;
    }
  };

  const fetchCombination = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "hec/combination/getCombinations"
      );
      const combinationList = await response.data;
      setCombinations(combinationList);
      return combinationList;
    } catch {
      return null;
    }
  };

  const fetchAcademicYear = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL + "hec/academic/getAcademicYears"
      );
      const academicYearList = await response.data;
      setAcademicYears(academicYearList);
      return academicYearList;
    } catch {
      return null;
    }
  };

  const validateAccountForm = () => {
    const errors = {};
    const nameRegex = /^[A-Za-zÀ-ÿ\s'-]+$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!firstNameAccount.trim()) {
      errors.firstName = "First name is required.";
    } else if (!nameRegex.test(firstNameAccount.trim())) {
      errors.firstName = "First name must contain letters only.";
    }

    if (!lastNameAccount.trim()) {
      errors.lastName = "Last name is required.";
    } else if (!nameRegex.test(lastNameAccount.trim())) {
      errors.lastName = "Last name must contain letters only.";
    }

    if (!phoneNumberAccount.trim()) {
      errors.phoneNumber = "Phone number is required.";
    } else if (!/^\d{10}$/.test(phoneNumberAccount.trim())) {
      errors.phoneNumber = "Phone number must be exactly 10 digits.";
    }

    if (!nationalIdAccount.trim()) {
      errors.nationalId = "National ID is required.";
    } else if (!/^\d{16}$/.test(nationalIdAccount.trim())) {
      errors.nationalId = "National ID must be exactly 16 digits.";
    }

    if (!emailAccount.trim()) {
      errors.email = "Email is required.";
    } else if (!emailRegex.test(emailAccount.trim())) {
      errors.email = "Please enter a valid email address.";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const createAccountAuthentication = async () => {
    // Validate field formats first
    if (!validateAccountForm()) {
      toast.warning("Please fix the highlighted errors before submitting.", {
        position: "top-center",
        autoClose: 6000,
        theme: "colored",
      });
      return;
    }

    // Validate password strength before submission
    if (!passwordStrength.isValid && passwordAccount) {
      toast.error(
        "Please create a stronger password that meets all requirements.",
        {
          position: "top-center",
          autoClose: 10000,
          theme: "colored",
        }
      );
      return;
    }

    // Check if passwords match
    if (passwordAccount !== passwordCheck) {
      toast.error("Passwords do not match. Please confirm your password.", {
        position: "top-center",
        autoClose: 10000,
        theme: "colored",
      });
      return;
    }

    if (
      firstNameAccount &&
      lastNameAccount &&
      nationalIdAccount &&
      emailAccount &&
      passwordAccount &&
      phoneNumberAccount &&
      passwordStrength.isValid
    ) {
      await axios
        .post(
          process.env.REACT_APP_BASE_URL + "hec/users/saveUser",
          createAccountData
        )
        .then((response) => {
          toast.success("The account is created successfully.", {
            position: "top-center",
            autoClose: 15000,
            theme: "colored",
          });
          clearTheInputCreate();
        })
        .catch((error) => {
          if (error.response.status === 409) {
            toast.info("You User Name is already taken, please change it", {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            });
          } else if (error.response.status === 302) {
            toast.info("Your account is already exists", {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            });
          }
        });
    } else {
      toast.warning("Please, provide all neccessary information", {
        position: "top-center",
        autoClose: 15000,
        theme: "colored",
      });
    }
  };

  const validateToken = async () => {
    if (loginAuthen) {
      await axios
        .get(
          process.env.REACT_APP_BASE_URL +
            "hec/users/validetetoken?token=" +
            loginAuthen
        )
        .then((response) => {
          setOpenModal(false);

          if (userRole === "Admin" || userRole === "DG") {
            nav("/dashboard");
          } else if (userRole === "SCHOLARSHIP_OWNER") {
            nav("/applicantsList");
          } else if (userRole === "HLI_ADMIN") {
            nav("/hliAdmin");
          } else {
            nav("/studentPortal");
          }
        })
        .catch((error) => {
          setEmailForget("");
          if (error.response.status === 409 || error.response.status === 404) {
            toast.info("Invalid token", {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            });
            return null;
          } else {
            toast.info("An error occurred while sending email", {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            });
            return null;
          }
        });
    } else {
      toast.warning("Please, provide all neccessary information", {
        position: "top-center",
        autoClose: 15000,
        theme: "colored",
      });
    }
  };

  //resetting password
  const sendEmail = async () => {
    if (emailForget) {
      await axios
        .get(
          process.env.REACT_APP_BASE_URL +
            "hec/users/resetPassword?userName=" +
            emailForget +
            "&tokenType=RESET"
        )
        .then((response) => {
          setEmailForget("");
          toast.success(
            "Email with reset Password has been send successfully, please check your email",
            {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            }
          );
          setEmailSendSucceed(true);
          return null;
        })
        .catch((error) => {
          setEmailForget("");
          if (error.response.status === 409 || error.response.status === 404) {
            toast.info("That email is not found", {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            });
            return null;
          } else {
            toast.info("An error occurred while sending email", {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            });
            return null;
          }
        });
    } else {
      toast.warning("Please, provide all neccessary information", {
        position: "top-center",
        autoClose: 15000,
        theme: "colored",
      });
    }
  };

  const resetNewPassword = async () => {
    if (emailForget && newPassword) {
      await axios
        .put(
          process.env.REACT_APP_BASE_URL +
            `hec/users/resetPassword?userName=${emailForget}&password=${newPassword}&token=${token}`
        )
        .then((response) => {
          toast.success("Password is reset successfully, go back to login", {
            position: "top-center",
            autoClose: 15000,
            theme: "colored",
          });
        })
        .catch((error) => {
          toast.info("Invalid user name or token", {
            position: "top-center",
            autoClose: 15000,
            theme: "colored",
          });
        });
    } else {
      toast.warning("Please, provide all neccessary information", {
        position: "top-center",
        autoClose: 15000,
        theme: "colored",
      });
    }
  };

  const resetNewPasswordWithNationalId = async () => {
    if (emailForget && newPassword && nationalId) {
      await axios
        .put(
          process.env.REACT_APP_BASE_URL +
            `hec/users/resetPassword?userName=${emailForget}&password=${newPassword}&nationalId=${nationalId}`
        )
        .then((response) => {
          toast.success("Password is reset successfully, go back to login", {
            position: "top-center",
            autoClose: 15000,
            theme: "colored",
          });
        })
        .catch((error) => {
          toast.info("Invalid user name or token", {
            position: "top-center",
            autoClose: 15000,
            theme: "colored",
          });
        });
    } else {
      toast.warning("Please, provide all neccessary information", {
        position: "top-center",
        autoClose: 15000,
        theme: "colored",
      });
    }
  };

  const resetToLogin = () => {
    // Reset all state variables to their initial values
    setHec(false);
    setLogin(true);
    setRegister(false);
    setLocalLoan(false);
    setApplicationForm(true);
    setCreateAccount(false);
    setForgetPassword(false);
    // Clear all form inputs
    clearTheInput();
  };

  const claimBody = {
    studentNumber: claimRegistration,
    claimDescription: claim,
    claimType: claimType,
  };

  const sendClaim = async () => {
    if (claim && claimRegistration) {
      await axios
        .post(
          process.env.REACT_APP_BASE_URL + "hec/studentClaim/saveClaim",
          claimBody
        )
        .then((response) => {
          setClaim("");
          setClaimRegistration("");
          if (
            claimType ===
            "Students meeting selection criteria and didn’t apply for study loan"
          ) {
            toast.success("Your claim is received, Please apply", {
              position: "top-center",
              autoClose: 15000,
              theme: "colored",
            });
            setLocalLoan(true);
            setApplicationForm(true);
            setCreateAccount(true);
            setForgetPassword(false);
            setPressedRegNumber(true);
            setOpenClaimModal(false);
          } else {
            toast.success(
              "Your claim is received, we will give you the response soon.",
              {
                position: "top-center",
                autoClose: 15000,
                theme: "colored",
              }
            );
          }
        })
        .catch((error) => {
          setClaim("");
          setClaimRegistration("");
          toast.info("Your claim is already received", {
            position: "top-center",
            autoClose: 15000,
            theme: "colored",
          });
        });
    } else {
      toast.warning("Please, provide all neccessary information", {
        position: "top-center",
        autoClose: 15000,
        theme: "colored",
      });
      setClaim("");
      setClaimRegistration("");
    }
  };

  const fetchScholarshipsByAcademicYear = async (academicYearId) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BASE_URL +
          `hec/abroad/find-scholarships?academicYear=${academicYearId}`
      );
      setScholarshipData(response.data || []);
      return response.data || [];
    } catch (error) {
      setScholarshipData([]);
    } finally {
      setLoading(false);
    }
  };

  // Auto-scroll effect
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    
    if (!scrollContainer || !isAutoScrolling || scholarshipData.length === 0) return;

    const scrollInterval = setInterval(() => {
      if (!isAutoScrolling) return;

      const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
      
      // If reached bottom, pause for 2 seconds then restart from top
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        setTimeout(() => {
          if (scrollContainer && isAutoScrolling) {
            scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
          }
        }, 2000);
      } else {
        // Scroll down by 1 pixel every 30ms for smooth movement
        scrollContainer.scrollBy({ top: 1, behavior: 'auto' });
      }
    }, 30);

    return () => clearInterval(scrollInterval);
  }, [isAutoScrolling, scholarshipData]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (pressedRegNumber) {
        getBursaryApplication();
      }
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [registrationNumber]);

  useQuery({
    queryKey: ["districts"],
    queryFn: () => fetchDistricts(),
    retry: 6,
  });

  useQuery({
    queryKey: ["areasKey"],
    queryFn: () => fetchStudyAreas(),
    retry: 6,
  });

  useQuery({
    queryKey: ["combinationsKey"],
    queryFn: () => fetchCombination(),
    retry: 6,
  });

  useQuery({
    queryKey: ["academicYearKey"],
    queryFn: () => fetchAcademicYear(),
    retry: 6,
  });

  const claiming = () => {
    setOpenClaimModal(true);
  };

  const updatePhoneNumberAndNationalId = () => {
    setOpenModalForUpdate(true);
  };

  useQuery({
    queryKey: ["scholarshipAcademicYearKey"],
    queryFn: () => fetchScholarshipsByAcademicYear(new Date().getFullYear()-1),
    retry: 6,
  });

  const nesalogoPosition = () => {
    return (
      <>
        <div className="flex justify-center mb-6">
          <div className="w-28">
            <img src={heclogo} alt="HEC" className="w-full h-auto" />
          </div>
        </div>
      </>
    );
  };

  if (!localLoan) {
    return (
      <div className="min-h-screen flex flex-col lg:flex-row w-full bg-inherit">
        {/* Login Section - 60% on large screens */}
        <div className="w-full lg:w-[40%] flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8 bg-white z-10 relative">
          {login && !register ? (
            <div className="w-full max-w-md space-y-8">
              {nesalogoPosition()}
              {isHec ? (
                <>
                  <div className="text-center">
                    <h4 className="text-3xl md:text-4xl font-bold text-navy-700 dark:text-black">
                      Sign In
                    </h4>
                  </div>

                  <div className="space-y-6">
                    <div>
                      <label
                        htmlFor="userEmail"
                        className="block text-sm font-medium text-gray-900 dark:text-black"
                      >
                        Email*
                      </label>
                      <input
                        type="email"
                        id="userEmail"
                        onChange={(e) => setEmailLogIn(e.target.value.trim())}
                        value={emailLogIn}
                        className="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-100"
                        placeholder="mail@info.com"
                        required
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="userPassword"
                        className="block text-sm font-medium text-gray-900 dark:text-black"
                      >
                        Password*
                      </label>
                      <input
                        type="password"
                        id="userPassword"
                        onChange={(e) => setPasswordLogIn(e.target.value)}
                        value={passwordLogIn}
                        className="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-100"
                        required
                      />
                    </div>

                    <div className="flex items-center justify-between">
                      <button
                        onClick={() => {
                          setLocalLoan(true);
                          setCreateAccount(true);
                          setForgetPassword(true);
                        }}
                        className="text-sm font-medium text-cyan-800 hover:text-cyan-900"
                      >
                        Forgot Password?
                      </button>
                    </div>

                    <button
                      className="w-full rounded-lg bg-cyan-800 px-4 py-3 text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                      onClick={authentication}
                    >
                      Sign In
                    </button>
                    <Modal
                      show={openModalLogin}
                      size="md"
                      onClose={() => setOpenModalLogin(false)}
                      popup
                    >
                      <Modal.Header />
                      <Modal.Body>
                        <div className="text-center">
                          <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                          <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Check your email and send the token you got from
                            there.
                          </h3>
                          <div className="mb-2 block">
                            <input
                              type="text"
                              id="userPassword"
                              onChange={(e) => setLoginAuthen(e.target.value)}
                              value={loginAuthen}
                              className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-100 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                              required
                            />
                          </div>

                          <div className="flex justify-center gap-4">
                            <Button color="success" onClick={validateToken}>
                              Send
                            </Button>
                            <Button color="gray" onClick={logout}>
                              No, cancel
                            </Button>
                          </div>
                        </div>
                      </Modal.Body>
                    </Modal>
                  </div>
                </>
              ) : (
                <div className="text-center space-y-6">
                  <button
                    className="w-full rounded-lg bg-cyan-800 px-4 py-3 text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                    onClick={() => setHec(true)}
                  >
                    Login
                  </button>
                </div>
              )}

              {isHec && (
                <div className="text-center mt-4">
                  <span className="text-sm text-gray-600">
                    Not registered yet?{" "}
                    <button
                      onClick={() => {
                        setLogin(false);
                        setRegister(true);
                        setLocalLoan(false);
                      }}
                      className="text-cyan-800 hover:text-cyan-900 font-medium"
                    >
                      Create an account
                    </button>
                  </span>
                </div>
              )}
              {!isHec && (
                <div className="mt-8 space-y-4">
                  {!showLocalLoanOptions ? (
                    <button
                      onClick={() => setShowLocalLoanOptions(true)}
                      className="w-full rounded-lg bg-cyan-800 px-4 py-3 text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 font-medium"
                    >
                      Local Loan Applicants
                    </button>
                  ) : (
                    <>
                      <button
                        onClick={() => setShowLocalLoanOptions(false)}
                        className="w-full rounded-lg bg-gray-600 px-4 py-3 text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 font-medium"
                      >
                        ← Back
                      </button>
                      
                      <button
                        onClick={() => {
                          setLocalLoan(true);
                          setApplicationForm(true);
                          setCreateAccount(true);
                          setForgetPassword(false);
                          setPressedRegNumber(true);
                        }}
                        className="w-full rounded-lg border border-cyan-800 px-4 py-3 text-cyan-800 hover:bg-cyan-50 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                      >
                        Apply Local Loan (Undergraduate)
                      </button>

                      <button
                        onClick={() => {
                          setLocalLoan(true);
                          setApplicationForm(false);
                          setCreateAccount(true);
                          setForgetPassword(false);
                        }}
                        className="w-full rounded-lg border border-cyan-800 px-4 py-3 text-cyan-800 hover:bg-cyan-50 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                      >
                        Requested Loan Results
                      </button>
                      <button
                        onClick={claiming}
                        className="w-full rounded-lg border border-cyan-800 px-4 py-3 text-cyan-800 hover:bg-cyan-50 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                      >
                        Submit Claim
                      </button>
                      <button
                        onClick={updatePhoneNumberAndNationalId}
                        className="w-full rounded-lg border border-cyan-800 px-4 py-3 text-cyan-800 hover:bg-cyan-50 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                      >
                        Update National ID and Phone Number
                      </button>
                    </>
                  )}
                </div>
              )}
              <Modal
                show={openClaimModal}
                onClose={() => setOpenClaimModal(false)}
              >
                <Modal.Header>
                  <div className="flex flex-col">
                    <div className="text-2xl font-bold text-navy-700 dark:text-slate-800 flex-1">
                      Application Result Claim
                    </div>
                    <p className="text-sm text-gray-600 dark:text-slate-500 mt-1">
                      If you believe your application was not reviewed fairly or contains an error, you may submit a formal claim for reconsideration below.
                    </p>
                  </div>
                </Modal.Header>
                <Modal.Body>
                  <div className="space-y-6">
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                      Submit Your Claim
                    </h3>
                    <div>
                      <div className="mb-2 block">
                        <Label htmlFor="claimReg" value="Registration Number/ National ID:" />
                      </div>
                      <input
                        type="text"
                        id="claimReg"
                        onChange={(e) => setClaimRegistration(e.target.value)}
                        value={claimRegistration}
                        placeholder="e.g. 2020-XXX-XXX"
                        className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-100 dark:text-gray-900 dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                        required
                      />
                    </div>
                    <div className="">
                      <Label htmlFor="claimType" value="Please, tell us about your claim:" />
                      <input
                        type="text"
                        id="claimType"
                        value={claimType}
                        onChange={(e) => setClaimType(e.target.value)}
                        placeholder="Describe your claim..."
                        className="block w-full mt-2 rounded-lg border border-gray-300 bg-gray-50 p-2 text-sm text-black focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400"
                      />
                    </div>
                    <div>
                      <div className="mb-2 block">
                        <Label htmlFor="claim" value="Reason" />
                      </div>
                      <Textarea
                        id="claim"
                        value={claim}
                        onChange={(e) => setClaim(e.target.value)}
                        placeholder="Please explain clearly why you are claiming for a result review."
                        required
                        rows={4}
                        maxLength={255}
                      />
                    </div>
                    <div className="flex items-center">
                      <Button onClick={sendClaim}>Submit Claim</Button>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    color="gray"
                    onClick={() => {
                      setOpenClaimModal(false);
                      clearResultFild();
                    }}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>

              {/** This the modal for updating the national ID and phone Number */}
              <Modal
                show={openModalForUpdate}
                size="md"
                onClose={() => setOpenModalForUpdate(false)}
                popup
              >
                <Modal.Header />
                <Modal.Body>
                  <div className="text-center">
                    <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                    <h3 className="mb-5 text-lg font-normal text-rose-700 dark:text-gray-400">
                      Enter your Reg Number, A correct National ID, and
                      Telephone Number linked to your National ID.
                    </h3>
                    <div className="mb-2 block">
                      <input
                        type="text"
                        id="registrationNumberUpdate"
                        placeholder="REG NUMBER"
                        onChange={(e) => setRegistrationNumber(e.target.value)}
                        value={registrationNumber}
                        className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-100 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                        required
                      />
                    </div>
                    <div className="mb-2 block">
                      <input
                        type="text"
                        placeholder="Phone Number"
                        id="phoneNumberUpdate"
                        maxLength={10}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        value={phoneNumber}
                        className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-100 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                        required
                      />
                    </div>
                    <div className="mb-2 block">
                      <input
                        type="text"
                        id="nationalIdUpdate"
                        placeholder="National ID"
                        maxLength={16}
                        onChange={(e) => setNationalId(e.target.value)}
                        value={nationalId}
                        className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-100 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                        required
                      />
                    </div>

                    <div className="flex justify-center gap-4">
                      <Button color="success" onClick={updatePhoneNumber}>
                        Update
                      </Button>
                      <Button
                        color="gray"
                        onClick={() => setOpenModalForUpdate(false)}
                      >
                        No, Cancel
                      </Button>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>

              {/* Scholarship Modal */}
              <Modal
                show={openScholarshipModal}
                size="7xl"
                onClose={() => setOpenScholarshipModal(false)}
              >
                <Modal.Header>
                  <div className="flex items-center justify-center gap-2">
                    <GraduationCap className="w-8 h-8 text-cyan-900" />
                    <h2 className="text-2xl font-bold text-cyan-900">Available Scholarships</h2>
                  </div>
                </Modal.Header>
                <Modal.Body className="max-h-[80vh] overflow-y-auto">
                  {loading ? (
                    <div className="flex items-center justify-center py-12">
                      <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-cyan-800 mx-auto mb-4"></div>
                        <p className="text-cyan-800 font-medium">Loading Scholarships...</p>
                      </div>
                    </div>
                  ) : openScholarships.length > 0 ? (
                    <div className="space-y-6">
                      {openScholarships.map((scholarship, index) => {
                        // Calculate status based on dates
                        const now = new Date();
                        const endDate = new Date(scholarship.endDate);
                        const startDate = new Date(scholarship.startDate);
                        const daysUntilEnd = Math.ceil((endDate - now) / (1000 * 60 * 60 * 24));
                        
                        let status = 'Open';
                        if (now > endDate) {
                          status = 'Closed';
                        } else if (daysUntilEnd <= 7) {
                          status = 'Closing Soon';
                        } else if (now < startDate) {
                          status = 'Coming Soon';
                        }

                        return (
                          <div
                            key={scholarship.id}
                            className="bg-white rounded-xl shadow-lg p-6 border border-gray-200 hover:shadow-xl transition-all duration-300"
                          >
                            {/* Scholarship Header */}
                            <div className="flex items-start justify-between mb-4">
                              <div className="flex-1">
                                <h3 className="text-xl font-bold text-gray-900 mb-2">
                                  {scholarship.name}
                                </h3>
                                <div className="flex items-center gap-2 mb-3 flex-wrap">
                                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                                    <Globe className="w-4 h-4 mr-1" />
                                    {scholarship.countryName}
                                  </span>
                                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
                                    <Building2 className="w-4 h-4 mr-1" />
                                    {scholarship.scholarshipType}
                                  </span>
                                  <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                                    <BookOpen className="w-4 h-4 mr-1" />
                                    {scholarship.educationPrograms?.length || 0} Programs
                                  </span>
                                </div>
                              </div>
                              <div className={`px-4 py-2 rounded-full text-sm font-semibold ${getStatusColor(status)}`}>
                                {status}
                              </div>
                            </div>

                            {/* Scholarship Description */}
                            {scholarship.description && (
                              <div className="mb-4">
                                <p className="text-gray-600 text-sm bg-gray-50 p-4 rounded-lg">
                                  {scholarship.description}
                                </p>
                              </div>
                            )}
                            
                            {/* Timeline */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 text-sm">
                              <div className="flex items-center text-green-600">
                                <Calendar className="w-4 h-4 mr-2" />
                                <span><strong>Start:</strong> {new Date(scholarship.startDate).toLocaleDateString()}</span>
                              </div>
                              <div className="flex items-center text-red-600">
                                <CalendarClock className="w-4 h-4 mr-2" />
                                <span><strong>Deadline:</strong> {new Date(scholarship.endDate).toLocaleDateString()}</span>
                              </div>
                            </div>

                            {/* Education Programs */}
                            {scholarship.educationPrograms && scholarship.educationPrograms.length > 0 && (
                              <div className="bg-gray-50 rounded-lg p-4">
                                <h4 className="font-semibold text-cyan-900 text-base mb-3 flex items-center">
                                  <BookOpen className="w-5 h-5 mr-2" />
                                  Available Programs ({scholarship.educationPrograms.length})
                                </h4>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                  {scholarship.educationPrograms.map((program, programIndex) => (
                                    <div key={program.id} className="bg-white rounded-lg p-4 shadow-sm border">
                                      <div className="flex items-start justify-between mb-2">
                                        <h5 className="font-medium text-gray-900 text-sm">
                                          {program.programName}
                                        </h5>
                                        <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                                          {program.studyYears} years
                                        </span>
                                      </div>
                                      <div className="flex items-center text-sm text-gray-600 mb-2">
                                        <School className="w-4 h-4 mr-1" />
                                        {program.universityName}
                                      </div>
                                      <div className="flex items-center text-xs text-gray-500 mb-3">
                                        <Calendar className="w-3 h-3 mr-1" />
                                        {new Date(program.startDate).toLocaleDateString()} - {new Date(program.endDate).toLocaleDateString()}
                                      </div>
                                      
                                      {/* Requirements */}
                                      {program.requirements && program.requirements.length > 0 && (
                                        <div>
                                          <p className="text-xs font-medium text-gray-700 mb-2">Requirements:</p>
                                          <div className="flex flex-wrap gap-1">
                                            {program.requirements.map((req, reqIndex) => (
                                              <span key={req.id} className="inline-flex items-center px-2 py-1 rounded-md text-xs bg-blue-100 text-blue-800">
                                                <FileText className="w-3 h-3 mr-1" />
                                                {req.name}
                                              </span>
                                            ))}
                                            {/* {program.requirements.length > 4 && (
                                              <span className="inline-flex items-center px-2 py-1 rounded-md text-xs bg-gray-100 text-gray-600">
                                                +{program.requirements.length - 4} more
                                              </span>
                                            )} */}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}

                            {/* Call to Action */}
                            <div className="flex items-center justify-between pt-4 border-t border-gray-200 mt-4">
                              <div className="flex items-center text-sm text-gray-500">
                                <Calendar className="w-4 h-4 mr-1" />
                                Posted: {new Date(scholarship.creationDate).toLocaleDateString()}
                              </div>
                              <div className="flex gap-2">
                                {status === 'Open' || status === 'Closing Soon' ? (
                                  <button 
                                    className="bg-gradient-to-r from-cyan-600 to-cyan-700 text-white px-6 py-2 rounded-lg text-sm font-medium hover:from-cyan-700 hover:to-blue-700 transition-all duration-200 transform hover:scale-105 shadow-md flex items-center"
                                    onClick={() => {
                                      setOpenScholarshipModal(false);
                                      setHec(true);
                                    }}
                                  >
                                    <ArrowLeft className="w-4 h-4 mr-2"/>
                                    Login to Apply
                                  </button>
                                ) : status === 'Coming Soon' ? (
                                  <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-2 rounded-lg text-sm font-medium cursor-not-allowed opacity-75 flex items-center">
                                    <Timer className="w-4 h-4 mr-2" />
                                    Opening Soon
                                  </div>
                                ) : (
                                  <div className="bg-gradient-to-r from-gray-400 to-gray-500 text-white px-6 py-2 rounded-lg text-sm font-medium cursor-not-allowed opacity-75 flex items-center">
                                    <XCircle className="w-4 h-4 mr-2" />
                                    Applications Closed
                                  </div>
                                )}
                              </div>
                            </div>

                            {/* Urgency Indicator */}
                            {status === 'Closing Soon' && (
                              <div className="bg-red-50 border border-red-200 rounded-lg p-3 flex items-center mt-4">
                                <AlertTriangle className="w-5 h-5 mr-2 text-red-600 animate-pulse" />
                                <span className="text-red-700 text-sm font-medium">
                                  Hurry! Only {daysUntilEnd} day{daysUntilEnd !== 1 ? 's' : ''} left to apply
                                </span>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <div className="flex items-center justify-center py-12">
                      <div className="text-center bg-gray-50 rounded-xl p-8">
                        <Search className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                        <h3 className="text-xl font-bold text-gray-900 mb-2">No Scholarships Available</h3>
                        <p className="text-gray-600">Check back later for new opportunities!</p>
                      </div>
                    </div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <div className="flex items-center justify-between w-full">
                    <div className="text-sm text-gray-500">
                      {openScholarships.length} scholarship{openScholarships.length !== 1 ? 's' : ''} found
                    </div>
                    <Button 
                      color="gray" 
                      onClick={() => setOpenScholarshipModal(false)}
                    >
                      Close
                    </Button>
                  </div>
                </Modal.Footer>
              </Modal>
            </div>
          ) : (
            // Registration form with similar responsive styling
            <div className="w-full max-w-2xl space-y-8 px-4">
              <h4 className="text-3xl md:text-4xl font-bold text-center text-navy-700 dark:text-black">
                Sign Up
              </h4>

              <div className="grid grid-cols-2 gap-2 mb-2">
                <div className="col-span-2 sm:col-span-1">
                  {/* First Name */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="fName"
                      onChange={(e) => {
                        setFirstNameAccount(e.target.value);
                        if (formErrors.firstName) setFormErrors((prev) => ({ ...prev, firstName: undefined }));
                      }}
                      value={firstNameAccount}
                      className={`block w-full rounded-lg border p-1.5 text-sm text-gray-900 focus:ring-blue-500 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 ${formErrors.firstName ? "border-red-500 bg-red-50 focus:border-red-500" : "border-gray-300 bg-gray-50 focus:border-blue-500"}`}
                      placeholder="First name"
                      required
                    />
                    {formErrors.firstName && <p className="mt-1 text-xs text-red-600">{formErrors.firstName}</p>}
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  {/* Last Name */}
                  <div className="">
                    <input
                      type="text"
                      id="lName"
                      onChange={(e) => {
                        setLastNameAccount(e.target.value);
                        if (formErrors.lastName) setFormErrors((prev) => ({ ...prev, lastName: undefined }));
                      }}
                      value={lastNameAccount}
                      className={`block w-full rounded-lg border p-1.5 text-sm text-gray-900 focus:ring-blue-500 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 ${formErrors.lastName ? "border-red-500 bg-red-50 focus:border-red-500" : "border-gray-300 bg-gray-50 focus:border-blue-500"}`}
                      placeholder="Last Name"
                      required
                    />
                    {formErrors.lastName && <p className="mt-1 text-xs text-red-600">{formErrors.lastName}</p>}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-2 mb-2">
                <div className="col-span-2 sm:col-span-1">
                  {/* Phone Number */}
                  <div className="">
                    <input
                      type="text"
                      id="phoneNumber"
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                        setPhoneNumberAccount(val);
                        if (formErrors.phoneNumber) setFormErrors((prev) => ({ ...prev, phoneNumber: undefined }));
                      }}
                      value={phoneNumberAccount}
                      className={`block w-full rounded-lg border p-1.5 text-sm text-gray-900 focus:ring-blue-500 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 ${formErrors.phoneNumber ? "border-red-500 bg-red-50 focus:border-red-500" : "border-gray-300 bg-gray-50 focus:border-blue-500"}`}
                      placeholder="Phone Number (10 digits)"
                      required
                    />
                    {formErrors.phoneNumber && <p className="mt-1 text-xs text-red-600">{formErrors.phoneNumber}</p>}
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  {/* National ID */}
                  <div className="">
                    <input
                      type="text"
                      id="nationalID"
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "").slice(0, 16);
                        setNationalIdAccount(val);
                        if (formErrors.nationalId) setFormErrors((prev) => ({ ...prev, nationalId: undefined }));
                      }}
                      value={nationalIdAccount}
                      className={`block w-full rounded-lg border p-1.5 text-sm text-gray-900 focus:ring-blue-500 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 ${formErrors.nationalId ? "border-red-500 bg-red-50 focus:border-red-500" : "border-gray-300 bg-gray-50 focus:border-blue-500"}`}
                      placeholder="National ID (16 digits)"
                      required
                    />
                    {formErrors.nationalId && <p className="mt-1 text-xs text-red-600">{formErrors.nationalId}</p>}
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  {/* Gender */}
                  <select
                    id="genderId"
                    value={genderAccount}
                    disabled={gender ? true : false}
                    onChange={(e) => setGenderAccount(e.target.value)}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-black focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400"
                  >
                    <option defaultValue>Select Gender</option>
                    <option value="MALE">MALE</option>
                    <option value="FEMALE">FEMALE</option>
                  </select>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  {/* Email */}
                  <div className="">
                    <input
                      type="text"
                      id="emailAccount"
                      onChange={(e) => {
                        setEmailAccount(e.target.value.trim());
                        if (formErrors.email) setFormErrors((prev) => ({ ...prev, email: undefined }));
                      }}
                      value={emailAccount}
                      className={`block w-full rounded-lg border p-1.5 text-sm text-gray-900 focus:ring-blue-500 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 ${formErrors.email ? "border-red-500 bg-red-50 focus:border-red-500" : "border-gray-300 bg-gray-50 focus:border-blue-500"}`}
                      placeholder="Enter your email"
                      required
                    />
                    {formErrors.email && <p className="mt-1 text-xs text-red-600">{formErrors.email}</p>}
                  </div>
                </div>
              </div>
              {/* Password Fields */}
              <div className="mb-2 flex flex-col lg:flex-row items-center gap-3 pt-2">
                <div className="w-full lg:w-1/2 mb-2 lg:mb-0">
                  <div className="">
                    <input
                      type="password"
                      id="password"
                      onChange={(e) => {
                        const newPassword = e.target.value;
                        setPasswordAccount(newPassword);
                        setPasswordStrength(
                          validatePasswordStrength(newPassword)
                        );
                      }}
                      value={passwordAccount}
                      className={`block w-full rounded-lg border p-1.5 text-sm text-gray-900 focus:ring-2 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 ${
                        passwordAccount && !passwordStrength.isValid
                          ? "border-red-500 bg-red-50 focus:border-red-500 focus:ring-red-500"
                          : passwordAccount && passwordStrength.isValid
                          ? "border-green-500 bg-green-50 focus:border-green-500 focus:ring-green-500"
                          : "border-gray-300 bg-gray-50 focus:border-blue-500 focus:ring-blue-500"
                      }`}
                      placeholder="Enter your password"
                      required
                    />

                    {/* Password Strength Indicator */}
                    {passwordAccount && (
                      <div className="mt-2">
                        <div className="flex items-center gap-2 mb-1">
                          <div className="flex gap-1 flex-1">
                            {[...Array(5)].map((_, i) => (
                              <div
                                key={i}
                                className={`h-1 flex-1 rounded ${
                                  i < passwordStrength.score
                                    ? passwordStrength.score === 5
                                      ? "bg-green-500"
                                      : passwordStrength.score >= 3
                                      ? "bg-yellow-500"
                                      : "bg-red-500"
                                    : "bg-gray-200"
                                }`}
                              />
                            ))}
                          </div>
                          <span className="text-xs font-medium">
                            {passwordStrength.score === 5
                              ? "Strong"
                              : passwordStrength.score >= 3
                              ? "Medium"
                              : "Weak"}
                          </span>
                        </div>
                        {passwordStrength.feedback.length > 0 && (
                          <div className="text-xs text-red-600">
                            <ul className="list-disc list-inside">
                              {passwordStrength.feedback.map((item, index) => (
                                <li key={index}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="w-full lg:w-1/2 mb-2 lg:mb-0">
                  <div className="">
                    <input
                      type="password"
                      id="passwordCheck"
                      onChange={(e) => setPasswordCheck(e.target.value)}
                      value={passwordCheck}
                      className={`block w-full rounded-lg border p-1.5 text-sm text-gray-900 focus:ring-2 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 ${
                        passwordCheck &&
                        passwordAccount &&
                        passwordCheck !== passwordAccount
                          ? "border-red-500 bg-red-50 focus:border-red-500 focus:ring-red-500"
                          : passwordCheck &&
                            passwordAccount &&
                            passwordCheck === passwordAccount
                          ? "border-green-500 bg-green-50 focus:border-green-500 focus:ring-green-500"
                          : "border-gray-300 bg-gray-50 focus:border-blue-500 focus:ring-blue-500"
                      }`}
                      placeholder="Confirm your password"
                      required
                    />

                    {/* Password Match Indicator */}
                    {passwordCheck && passwordAccount && (
                      <div className="mt-1 text-xs">
                        {passwordCheck === passwordAccount ? (
                          <span className="text-green-600 flex items-center gap-1">
                            <svg
                              className="w-3 h-3"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                clipRule="evenodd"
                              />
                            </svg>
                            Passwords match
                          </span>
                        ) : (
                          <span className="text-red-600 flex items-center gap-1">
                            <svg
                              className="w-3 h-3"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                clipRule="evenodd"
                              />
                            </svg>
                            Passwords do not match
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 mt-8">
                <button
                  onClick={resetToLogin}
                  className="w-full sm:w-1/2 rounded-lg border border-cyan-800 px-4 py-3 text-cyan-800 hover:bg-cyan-50 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                >
                  Cancel
                </button>
                <button
                  onClick={createAccountAuthentication}
                  className="w-full sm:w-1/2 rounded-lg bg-cyan-800 px-4 py-3 text-white hover:bg-cyan-700"
                >
                  Sign Up
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Scholarships Section - 60% on large screens */}
         <div className="w-full lg:w-[60%] hidden lg:block">
          {fetchScholarshipsByAcademicYearDiv()}
        </div> 
        
        {/* Mobile Scholarship Preview */}
        <div className="lg:hidden bg-[#f9fafb] text-black p-4 border border-gray-200 rounded-sm">
          <div className="text-center">
            <h3 className="font-bold mb-2 flex items-center justify-center gap-2">
              <GraduationCap className="w-5 h-5" />
              {openScholarships.length} Scholarships Available
            </h3>
            <p className="text-sm opacity-90 mb-3">Discover scholarship opportunities before you login</p>
            <button
              onClick={() => setOpenScholarshipModal(true)}
              className="bg-gradient-to-r from-cyan-600 to-cyan-700 text-white px-4 py-2 rounded-lg text-sm font-medium hover:from-cyan-700 hover:to-blue-700 transition-all duration-200 transform hover:scale-105 shadow-md flex items-center mx-auto"
            >
              <Search className="w-4 h-4 mr-2" />
              View Scholarships
            </button>
          </div>
        </div>
      </div>
    );
  } else if (localLoan && createAccount && !forgetPassword) {
    return (
      <div className="min-h-screen flex flex-col md:flex-row w-full">
        <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8">
          {applicationForm ? (
            <div className="xl:ml-[20vh] sm:ml-[1vh] md:mr-[20vh]  w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[900px] ">
              <h4 className="mt-8 text-4xl font-bold text-navy-700 dark:text-black">
                Application Form
              </h4>
              <div className="flex items-center">
                <p className="ml-2 mb-5 text-sm font-medium text-navy-700 dark:text-black">
                  Fill your information in the field below and click Apply
                </p>
              </div>
              <div className="grid grid-cols-2 gap-2 mb-2">
                <div className="col-span-2 sm:col-span-1">
                  {/* Registration Number */}
                  <div className="mb-2">
                    <input
                      type="text"
                      autoFocus
                      onChange={(e) => setRegistrationNumber(e.target.value)}
                      value={registrationNumber}
                      id="registrationNumber"
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400"
                      placeholder="Reg Number"
                      required
                    />
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  {/* First Name */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="fName"
                      disabled={true}
                      onChange={(e) => setFirstName(e.target.value)}
                      value={firstName}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400"
                      placeholder="First name"
                      required
                    />
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  {/* Last Name */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="lName"
                      disabled={true}
                      onChange={(e) => setLastName(e.target.value)}
                      value={lastName}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400"
                      placeholder="Last Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  {/* Gender */}
                  <select
                    id="countries"
                    value={gender}
                    disabled={gender ? true : false}
                    onChange={(e) => setGender(e.target.value)}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-black focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400"
                  >
                    <option defaultValue>Select Gender</option>
                    <option value="MALE">MALE</option>
                    <option value="FEMALE">FEMALE</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-2 mb-2">
                <div className="col-span-2 sm:col-span-1">
                  {/* Phone Number */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="phoneNumber"
                      disabled={phoneNumber ? true : false}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      value={phoneNumber}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400"
                      placeholder="Phone Number"
                      required
                    />
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  {/* National ID */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="nationalID"
                      disabled={nationalId ? true : false}
                      onChange={(e) => setNationalId(e.target.value)}
                      value={nationalId}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400"
                      placeholder="National ID"
                      required
                    />
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  {/* Father Name */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="fatherName"
                      onChange={(e) => setFatherName(e.target.value)}
                      value={fatherName}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400"
                      placeholder="Father Name"
                      required
                    />
                  </div>
                </div>
                <div className="col-span-2 sm:col-span-1">
                  {/* Mother Name */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="motherName"
                      onChange={(e) => setMotherName(e.target.value)}
                      value={motherName}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400"
                      placeholder="Mother Name"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="mb-2 flex flex-col lg:flex-row items-center gap-3 pt-2">
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  {/* Guardian */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="guardian"
                      onChange={(e) => setGuardianName(e.target.value)}
                      value={guardianName}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                      placeholder="Guardian"
                      required
                    />
                  </div>
                </div>
                {/* Reference Number */}
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  <div className="mb-2">
                    <input
                      type="text"
                      id="indexNumber"
                      disabled={true}
                      onChange={(e) => setIndexNumber(e.target.value)}
                      value={indexNumber}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                      placeholder="Index Number"
                      required
                    />
                  </div>
                </div>
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  {/* Email */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="email"
                      disabled={email ? true : false}
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                      placeholder="email"
                      required
                    />
                  </div>
                </div>
                <div className="w-full lg:w-1/4 mb-2 lg:mb-0">
                  {/* Marks */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="marks"
                      disabled={true}
                      onChange={(e) => setMarks(e.target.value)}
                      value={marks}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                      placeholder="marks"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="mb-2 flex flex-col lg:flex-row items-center gap-3 pt-2">
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  <select
                    id="countries"
                    onChange={(e) => setCombination(e.target.value)}
                    value={combination}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  >
                    <option defaultValue>
                      {combination ? combination : "Select combination"}
                    </option>
                    {combinations &&
                      !combination &&
                      combinations.map((combination) => (
                        <option
                          key={combination.combinationCode}
                          value={combination.combinationCode}
                        >
                          {combination.combinationName}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  <select
                    id="countries"
                    onChange={(e) => {
                      setStudyArea(e.target.value);
                    }}
                    value={studyArea}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  >
                    <option defaultValue>
                      {studyArea ? studyArea : "Select Study area"}
                    </option>
                    {studyAreas &&
                      !studyArea &&
                      studyAreas.map((study) => (
                        <option key={study.id}>{study.studyAreaName}</option>
                      ))}
                  </select>
                </div>
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  <select
                    id="countries"
                    onChange={(e) => setCompletionYear(e.target.value)}
                    value={completionYear}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  >
                    <option defaultValue>
                      {completionYear
                        ? completionYear
                        : "Select completion year"}
                    </option>
                    {academicYears &&
                      !completionYear &&
                      academicYears.map((academicYear) => (
                        <option
                          key={academicYear.id}
                          value={academicYear.academicYearCode}
                        >
                          {academicYear.academicYearName}
                        </option>
                      ))}
                  </select>
                </div>
                {/* Academic year Applying F-*/}
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  <select
                    id="countries"
                    onChange={(e) => setApplyingAcademic(e.target.value)}
                    value={applyingAcademic}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  >
                    <option defaultValue>
                      {applyingAcademic
                        ? applyingAcademic
                        : "Select Academic Year"}
                    </option>
                    {academicYears &&
                      !applyingAcademic &&
                      academicYears.map((academicYear) => (
                        <option
                          key={academicYear.id}
                          value={academicYear.academicYearCode}
                        >
                          {academicYear.academicYearName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="mb-2 flex flex-col lg:flex-row items-center gap-3 pt-3">
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  <select
                    id="countries"
                    onChange={(e) => {
                      setLoanCategory(e.target.value);
                    }}
                    value={loanCategory}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  >
                    {/* <option value="Living Allowance">Living Allowance</option>
                    <option value="Tuition Fees">Tuition Fees</option> */}
                    <option value="Tuition Fees and Living Allowance">
                      Tuition Fees and Living Allowance
                    </option>
                  </select>
                </div>
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  {/* Guardian */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="collegeId"
                      disabled={true}
                      onChange={(e) => setCollege(e.target.value)}
                      value={college}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                      placeholder="College"
                      required
                    />
                  </div>
                </div>
                {/* Reference Number */}
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  <div className="mb-2">
                    <input
                      type="text"
                      id="qualification"
                      disabled={true}
                      onChange={(e) => setQualification(e.target.value)}
                      value={qualification}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                      placeholder="Qualification Code"
                      required
                    />
                  </div>
                </div>
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  {/* Email */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="campusId"
                      disabled={true}
                      onChange={(e) => setCampus(e.target.value)}
                      value={campus}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                      placeholder="Campus"
                      required
                    />
                  </div>
                </div>
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  {/* Marks */}
                  <div className="mb-2">
                    <input
                      type="text"
                      id="educationLevelId"
                      disabled={true}
                      onChange={(e) => setEducationLevel(e.target.value)}
                      value={educationLevel}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                      placeholder="Education Level"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="mb-2 flex flex-col lg:flex-row items-center gap-3 pt-2">
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  <select
                    id="district"
                    value={district}
                    onChange={(e) => {
                      fetchLocations(e.target.value, "DISTRICT");
                      setDistrict(e.target.value);
                    }}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  >
                    <option defaultValue>Select District</option>
                    {districts &&
                      districts.map((district) => (
                        <option
                          key={district.locationCode}
                          value={district.locationCode}
                        >
                          {district.locationName}
                        </option>
                      ))}
                  </select>
                </div>
                {/* sector */}
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  <select
                    id="sector"
                    value={sector}
                    onChange={(e) => {
                      setsector(e.target.value);
                      fetchLocations(e.target.value, "SECTOR");
                    }}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  >
                    <option defaultValue>Select Sector</option>
                    {sectors &&
                      sectors.map((sector) => (
                        <option
                          key={sector.locationCode}
                          value={sector.locationCode}
                        >
                          {sector.locationName}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  <select
                    id="cell"
                    value={cell}
                    onChange={(e) => {
                      setCell(e.target.value);
                      fetchLocations(e.target.value, "CELL");
                    }}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  >
                    <option defaultValue>Select cell</option>
                    {cells &&
                      cells.map((cell) => (
                        <option
                          key={cell.locationCode}
                          value={cell.locationCode}
                        >
                          {cell.locationName}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="w-full lg:w-1/4 mb-3 lg:mb-0">
                  <select
                    id="village"
                    onChange={(e) => {
                      setVillage(e.target.value);
                      setSelectedVillage(true);
                    }}
                    value={village}
                    className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                  >
                    <option defaultValue>Select Village</option>
                    {villages &&
                      villages.map((village) => (
                        <option
                          key={village.locationCode}
                          value={village.locationCode}
                        >
                          {village.locationName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="mb-6 flex items-center  gap-3 pt-2">
                <div className="h-px w-full  dark:bg-navy-700">
                  <button
                    onClick={resetToLogin}
                    className="linear mt-2 w-full rounded-xl bg-cyan-800 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-red-400 active:bg-brand-700	 dark:bg-cyan-800	 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    Cancel
                  </button>
                </div>
                <div className="h-px w-full dark:bg-navy-700">
                  <button
                    onClick={applyForLocalLoan}
                    className="linear mt-2 w-full rounded-xl
                 bg-cyan-800 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700	 dark:bg-navy-700 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="mt-[10vh] xl:ml-[20vh] sm:ml-[1vh] md:mr-[20vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
              <h4 className="text-4xl font-bold text-navy-700 dark:text-slate-800">
                View Your Result
              </h4>

              <div className="mb-16 flex items-center  gap-3">
                {/* First Name */}
                <div className="h-px w-full  dark:bg-navy-700">
                  <div className="mb-6">
                    <label
                      htmlFor="checkRegistration"
                      className="mb-2 block text-sm font-medium text-gray-900 dark:text-black"
                    >
                      Registration Number*
                    </label>
                    <input
                      type="text"
                      id="checkRegistration"
                      onChange={(e) => setCheckResultRegNumber(e.target.value)}
                      value={checkResultRegNumber}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-200 dark:text-black dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                      placeholder="Enter your Registration Number here"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Checkbox */}
              <div className="pt-10">
                <button
                  className="linear mt-2 w-full rounded-xl bg-cyan-800 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white 
                dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  onClick={() => {
                    getResultByRegNumber();
                  }}
                >
                  VIEW RESULTS
                </button>
              </div>
              <div className="mt-4">
                <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
                  Back To login
                </span>
                <button
                  onClick={resetToLogin}
                  className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-cyan-800"
                >
                  Press here!
                </button>
              </div>
              <Modal show={openModal} onClose={() => setOpenModal(false)}>
                <Modal.Header>
                  <div className="flex">
                    <div className="text-2xl font-bold text-navy-700 dark:text-slate-800 flex-1">
                      STUDENT LOAN APPLICATION RESULTS
                    </div>
                    <div className="flex-none w-28">
                      {" "}
                      <img src={heclogo} alt="HEC" />
                    </div>
                  </div>
                </Modal.Header>
                <Modal.Body>
                  <div className="grid gap-6 mb-6 md:grid-cols-2">
                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        First name : {firstName}
                      </label>
                    </div>
                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Last name : {lastName}
                      </label>
                    </div>
                    {/* <div>
                      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        National ID : {nationalId}
                      </label>
                    </div> */}
                    <div>
                      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Registration Number : {registrationNumber}
                      </label>
                    </div>
                    {/* <div>
                      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        Study Area : {studyArea}
                      </label>
                    </div> */}
                    <div>
                      <label className="block mb-2 text-xl font-bold text-teal-700 dark:text-white">
                        Decision :{" "}
                        {bursaryStatus === "PENDING"
                          ? "UNDER REVIEW"
                          : bursaryStatus === "GRANTED"
                          ? "GRANTED"
                          : bursaryStatus === "REJECTED"
                          ? "REJECTED"
                          : bursaryStatus}
                      </label>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    color="gray"
                    onClick={() => {
                      setOpenModal(false);
                      clearResultFild();
                    }}
                  >
                    Close
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          )}
        </div>
        <div className="hidden md:block">
          <LogoComponent />
        </div>
      </div>
    );
  } else if (localLoan && createAccount && forgetPassword) {
    return (
      <>
        {emailSendSucceed ? (
          <div className="min-h-screen flex flex-col md:flex-row w-full">
            <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8">
              <div className="w-full max-w-md space-y-8">
                <h4 className="text-3xl md:text-4xl font-bold text-navy-700 dark:text-black">
                  Reset Your Password
                </h4>

                <div className="space-y-6">
                  <div>
                    <label
                      htmlFor="checkRegistration"
                      className="block text-sm font-medium text-gray-900 dark:text-black"
                    >
                      Please enter your email
                    </label>
                    <input
                      type="email"
                      id="checkRegistration"
                      value={emailForget}
                      onChange={(e) => setEmailForget(e.target.value.trim())}
                      className="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-100"
                      placeholder="email@example.com"
                      required
                    />
                  </div>
                </div>

                <div className="pt-10">
                  <button
                    className="w-full rounded-lg bg-cyan-800 px-4 py-3 text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                    onClick={sendEmail}
                  >
                    Search
                  </button>
                </div>
                <div className="mt-4">
                  <span className="text-sm font-medium text-navy-700 dark:text-gray-600">
                    Back To login
                  </span>
                  <button
                    onClick={resetToLogin}
                    className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-cyan-800"
                  >
                    Press here!
                  </button>
                </div>
              </div>
            </div>
            <div className="hidden md:block">
              <LogoComponent />
            </div>
          </div>
        ) : (
          <div className="min-h-screen flex flex-col md:flex-row w-full">
            <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-8">
              <div className="w-full max-w-md space-y-8">
                <h4 className="text-3xl md:text-4xl font-bold text-navy-700 dark:text-black">
                  New Password Detail
                </h4>

                <div className="space-y-6">
                  <div>
                    <label
                      htmlFor="checkRegistration"
                      className="block text-sm font-medium text-gray-900 dark:text-black"
                    >
                      Please enter your email
                    </label>
                    <input
                      type="email"
                      id="checkRegistration"
                      value={emailForget}
                      onChange={(e) => setEmailForget(e.target.value.trim())}
                      className="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-100"
                      placeholder="email@example.com"
                      required
                    />
                  </div>

                  <div>
                    <label
                      htmlFor="checkRegistration"
                      className="block text-sm font-medium text-gray-900 dark:text-black"
                    >
                      Please Enter your New Password
                    </label>
                    <input
                      type="password"
                      id="checkRegistration"
                      value={newPassword}
                      onChange={(e) => {
                        const password = e.target.value;
                        setNewPassword(password);
                        setPasswordStrength(validatePasswordStrength(password));
                      }}
                      className={`mt-1 block w-full rounded-lg border p-1.5 text-sm focus:ring-2 dark:bg-slate-100 ${
                        newPassword && !passwordStrength.isValid
                          ? "border-red-500 bg-red-50 focus:border-red-500 focus:ring-red-500"
                          : newPassword && passwordStrength.isValid
                          ? "border-green-500 bg-green-50 focus:border-green-500 focus:ring-green-500"
                          : "border-gray-300 bg-gray-50 focus:border-blue-500 focus:ring-blue-500"
                      }`}
                      required
                    />

                    {/* Password Strength Indicator */}
                    {newPassword && (
                      <div className="mt-2">
                        <div className="flex items-center gap-2 mb-1">
                          <div className="flex gap-1 flex-1">
                            {[...Array(5)].map((_, i) => (
                              <div
                                key={i}
                                className={`h-1 flex-1 rounded ${
                                  i < passwordStrength.score
                                    ? passwordStrength.score === 5
                                      ? "bg-green-500"
                                      : passwordStrength.score >= 3
                                      ? "bg-yellow-500"
                                      : "bg-red-500"
                                    : "bg-gray-200"
                                }`}
                              />
                            ))}
                          </div>
                          <span className="text-xs font-medium">
                            {passwordStrength.score === 5
                              ? "Strong"
                              : passwordStrength.score >= 3
                              ? "Medium"
                              : "Weak"}
                          </span>
                        </div>
                        {passwordStrength.feedback.length > 0 && (
                          <div className="text-xs text-red-600">
                            <ul className="list-disc list-inside">
                              {passwordStrength.feedback.map((item, index) => (
                                <li key={index}>{item}</li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  {/* <div className="">
                    <label
                      htmlFor="checkRegistration"
                      className="mb-2 block text-sm font-medium text-gray-900 dark:text-black"
                    >
                      Your Token from Email
                    </label>
                    <input
                      type="text"
                      id="checkRegistration"
                      value={token}
                      onChange={(e) => setToken(e.target.value)}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-100 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                      placeholder="xxx-xxx"
                      required
                    />
                  </div> */}

                  <div className="">
                    <label
                      htmlFor="checkRegistration"
                      className="mb-2 block text-sm font-medium text-gray-900 dark:text-black"
                    >
                      National ID Number
                    </label>
                    <input
                      type="text"
                      id="checkRegistration"
                      value={nationalId}
                      onChange={(e) => setNationalId(e.target.value)}
                      className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-1.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-slate-100 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
                      placeholder="National ID Number"
                      required
                    />
                  </div>
                </div>

                <div className="pt-5">
                  <button
                    className="w-full rounded-lg bg-cyan-800 px-4 py-3 text-white hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                    onClick={resetNewPasswordWithNationalId}
                  >
                    Reset
                  </button>
                </div>
                <div className="mt-4">
                  <span className="text-sm font-medium text-navy-700 dark:text-gray-600">
                    Back To login
                  </span>
                  <button
                    onClick={resetToLogin}
                    className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-cyan-800"
                  >
                    Press here!
                  </button>
                </div>
              </div>
            </div>
            <div className="hidden md:block">
              <LogoComponent />
            </div>
          </div>
        )}
      </>
    );
  }
}
